<app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
<mat-accordion id="Approvals">
  <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2">
    <mat-expansion-panel-header class="template-3-mat-panel ia-mat-panel">
      <div
        class="save_title w-100 d-flex align-items-center gap-2 justify-content-between"
      >
        <mat-panel-title>
          <span class="text-header inc-f"> Approval Details </span>
        </mat-panel-title>
        <button
          *ngIf="!versionHistoryData.isVersonHistory"
          class="text-primary save_btn mr-2 cursor-pointer"
          (click)="saveApprovalsData(); $event.stopPropagation()"
          [disabled]="isButtonDisabled ? true : !userPermissionList?.SaveApprovalsData"
        >
          <lucide-icon name="save" size="16" class="text-primary"></lucide-icon>
          Save
        </button>
      </div>
    </mat-expansion-panel-header>
    <div class="row ml-2 mt-1">
      <div class="col-lg-3 mb-3">
        <label class="control-label fw">Approvers</label>
        <mat-chip-grid class="t3_matchip" #approverInputList>
          <ng-container *ngFor="let item of approverFilterList">
            <mat-chip-row
              [selectable]="true"
              [removable]="true"
              (removed)="removeApprover(item.value)"
              class="mat-chip-category"
            >
              {{ item.name }}
              <mat-icon
                matChipRemove
                *ngIf="userPermissionList?.Approvers"
                >cancel</mat-icon
              >
            </mat-chip-row>
          </ng-container>
          <input
            class="form-control form-control-sm mat-autodd-input border-bottom"
            #approverInput
            [formControl]="searchApproverCntrl"
            [matAutocomplete]="approverAutoComplete"
            [matChipInputFor]="approverInputList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addApprover($event)"
            #approverAutoTrigger="matAutocompleteTrigger"
            placeholder="Type to filter or add new choice"
            [readonly]="!userPermissionList?.Approvers"
          />
        </mat-chip-grid>
        <mat-autocomplete
          #approverAutoComplete="matAutocomplete"
          (optionSelected)="selectedApproverEvent($event)"
        >
          <mat-option *ngFor="let obj of searchedApprovers" [value]="obj.value">
            <span class="option">
              {{ obj.name }}
            </span>
          </mat-option>
        </mat-autocomplete>
      </div>
      <div class="col-lg-3 mb-3">
        <label class="control-label fw">Approver Date</label>
        <div class="input-group input-group-sm">
          <input
            matInput
            [matDatepicker]="approverDate"
            (click)="approverDate.open()"
            class="form-control form-control-sm border-bottom"
            name="approverDate"
            [(ngModel)]="approvalsData.approverDate"
            [disabled]="!userPermissionList?.ApproverDate"
          />
          <div class="input-group-append">
            <span
              class="input-group-text fa fa-calendar"
              (click)="approverDate.open()"
            ></span>
          </div>
        </div>
        <mat-datepicker #approverDate></mat-datepicker>
      </div>
      <div class="col-lg-3 mb-3">
        <label class="control-label fw">Next Approval Due </label>
        <div class="input-group input-group-sm">
          <input
            matInput
            [matDatepicker]="nextApprovelDue"
            (click)="nextApprovelDue.open()"
            class="form-control form-control-sm border-bottom"
            name="nextApprovelDue"
            [(ngModel)]="approvalsData.nextApprovalDue"
            [disabled]="!userPermissionList?.NextApprovalDue"
          />
          <div class="input-group-append">
            <span
              class="input-group-text fa fa-calendar"
              (click)="nextApprovelDue.open()"
            ></span>
          </div>
        </div>
        <mat-datepicker #nextApprovelDue></mat-datepicker>
      </div>
      <div class="col-lg-3 mb-3">
        <label class="control-label fw">Confirm Approval</label>
        <div class="d-flex gap-2 flex-wrap">
          <div *ngFor="let item of approverFilterList">
            <input
              (change)="selectedApprovalName(item.value,$event)"
              type="checkbox"
              [checked]="item.isCheck"
              [disabled]="!userPermissionList?.ConfirmApproval"
            /><span class="ml-1">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-3 mb-3">
        <label class="control-label fw">Approval Status</label>
        <!-- ({{approvalsData.approvalStatus}}) ({{ selectedApprovers?.length ?? 0 }} of
        {{ approverFilterList?.length ?? 0 }})  -->
        <input type="text" class="form-control form-control-sm" name="ApprovalStatus"
        [(ngModel)]="approvalsData.approvalStatus" disabled>
       
      </div>
    </div>

    <div class="row ml-2 mt-1">
      <div class="col-lg-12">
        <div class="header-text">
          <span class="control-label fw d-block mb-2"> Approver Comments </span>
        </div>
        <app-ck-editor-revision
          *ngIf="user.fullName != ''"
          class="ck_editor_min_height"
          [accessType]="accessType"
          [data]="approvalsData.approverComments"
          [userInfo]="user"
          [noteId]="'ApproverComments'"
          [editorUsers]="approvalsData.muteApproverCommentsUsers"
          [selfAssessmentId]="summaryDetailsId"
          (childVariableChange)="
            onChildVariableChangeT3($event, 'ApproverComments')
          "
          (saveEditorDate)="onEditorSaveT3($event)"
          [isSaveDisable]="!userPermissionList?.ApproverComments"
        ></app-ck-editor-revision>
      </div>
    </div>
    <div class="row ml-2 pt-3">
      <div
        class="col-12 d-flex align-items-center justify-content-between gap-1"
      >
        <span class="cursor-pointer" (click)="uploadEvidenceApprovals()">
          <lucide-icon
            class="text-blue-lucide mr-1"
            size="15"
            name="upload"
          ></lucide-icon>
          <span class="text-blue ml-1 fw"
            >Upload Evidence - Approvals
            <i
              *ngIf="approvalsEvidanceLoader"
              class="fa fa-circle-o-notch fa-spin"
              style="font-size: 0.875rem; line-height: 1.5"
            ></i>
          </span>
          <input
            id="uploadApprovalsT3"
            (change)="handleFileInput($event.target.files)"
            type="file"
            multiple
            style="display: none"
          /><br />
        </span>
        <div>
          <span class="mr-2">Conditional Approval?</span
          ><input
            type="checkbox"
            [(ngModel)]="approvalsData.conditionalApproval"
            [disabled]="!userPermissionList?.ConditionalApproval"
            (change)="
              isReadyForConditionalApprovalClicked($event.target.checked)
            "
          />
        </div>
      </div>
      <div
        class="col-lg-12 mt-3"
        *ngIf="selfAssessmentDocument.length > 0 && tabName == 'Interpretation'"
      >
        <ng-container *ngFor="let docs of selfAssessmentDocument">
          <div class="file-div text-center" *ngIf="docs.fileType === 6">
            <span
              class="fa fa-trash pull-right delete-docs"
              (click)="openDeleteModel(docs.id)"
            ></span>
            <span
              class="cursor-pointer"
              (click)="
                downloadDocument(docs.id, docs.fileName, docs.fileExtension)
              "
            >
              <i
                class="fa fa-file-text fa-2x"
                *ngIf="docs.fileExtension === '.txt'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-text-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.eml' || docs.fileExtension === '.msg'
                "
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-pdf-o fa-2x"
                *ngIf="docs.fileExtension === '.pdf'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.doc'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.docx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xls'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xlsx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-o fa-2x"
                *ngIf="docs.fileExtension === '.csv'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-code-o fa-2x"
                *ngIf="docs.fileExtension === '.xml'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-archive-o fa-2x"
                *ngIf="docs.fileExtension === '.zip'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpeg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.png'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-powerpoint-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.ppt' ||
                  docs.fileExtension === '.pptx'
                "
                aria-hidden="true"
              ></i>
            </span>
            <div class="data-div">{{ docs.fileName }}</div>
          </div>
        </ng-container>
      </div>
      <div
        class="col-lg-12 mt-3"
        *ngIf="selfAssessmentDocument.length > 0 && tabName == 'Judgement'"
      >
        <ng-container *ngFor="let docs of selfAssessmentDocument">
          <div class="file-div text-center" *ngIf="docs.fileType === 10">
            <span
              class="fa fa-trash pull-right delete-docs"
              (click)="openDeleteModel(docs.id)"
            ></span>
            <span
              class="cursor-pointer"
              (click)="
                downloadDocument(docs.id, docs.fileName, docs.fileExtension)
              "
            >
              <i
                class="fa fa-file-text fa-2x"
                *ngIf="docs.fileExtension === '.txt'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-text-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.eml' || docs.fileExtension === '.msg'
                "
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-pdf-o fa-2x"
                *ngIf="docs.fileExtension === '.pdf'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.doc'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.docx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xls'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xlsx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-o fa-2x"
                *ngIf="docs.fileExtension === '.csv'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-code-o fa-2x"
                *ngIf="docs.fileExtension === '.xml'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-archive-o fa-2x"
                *ngIf="docs.fileExtension === '.zip'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpeg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.png'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-powerpoint-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.ppt' ||
                  docs.fileExtension === '.pptx'
                "
                aria-hidden="true"
              ></i>
            </span>
            <div class="data-div">{{ docs.fileName }}</div>
          </div>
        </ng-container>
      </div>
      <div
        class="col-lg-12 mt-3"
        *ngIf="selfAssessmentDocument.length > 0 && tabName == 'Approach'"
      >
        <ng-container *ngFor="let docs of selfAssessmentDocument">
          <div class="file-div text-center" *ngIf="docs.fileType === 14">
            <span
              class="fa fa-trash pull-right delete-docs"
              (click)="openDeleteModel(docs.id)"
            ></span>
            <span
              class="cursor-pointer"
              (click)="
                downloadDocument(docs.id, docs.fileName, docs.fileExtension)
              "
            >
              <i
                class="fa fa-file-text fa-2x"
                *ngIf="docs.fileExtension === '.txt'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-text-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.eml' || docs.fileExtension === '.msg'
                "
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-pdf-o fa-2x"
                *ngIf="docs.fileExtension === '.pdf'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.doc'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-word-o fa-2x"
                *ngIf="docs.fileExtension === '.docx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xls'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-excel-o fa-2x"
                *ngIf="docs.fileExtension === '.xlsx'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-o fa-2x"
                *ngIf="docs.fileExtension === '.csv'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-code-o fa-2x"
                *ngIf="docs.fileExtension === '.xml'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-archive-o fa-2x"
                *ngIf="docs.fileExtension === '.zip'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpeg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.jpg'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-image-o fa-2x"
                *ngIf="docs.fileExtension === '.png'"
                aria-hidden="true"
              ></i>
              <i
                class="fa fa-file-powerpoint-o fa-2x"
                *ngIf="
                  docs.fileExtension === '.ppt' ||
                  docs.fileExtension === '.pptx'
                "
                aria-hidden="true"
              ></i>
            </span>
            <div class="data-div">{{ docs.fileName }}</div>
          </div>
        </ng-container>
      </div>
    </div>
    <!-- <div class="row ml-2">
      <div class="col-12 mt-3">
        <input type="checkbox" [(ngModel)]="approvalsData.conditionalApproval" /><span class="ml-2">Conditional
          Approval?</span>
      </div>
    </div> -->
  </mat-expansion-panel>
</mat-accordion>
